import Backdrop from '@mui/material/Backdrop';
import { Spinner } from '@scale/scaleui';
import { useChatStoreExtract } from 'react-scale/components/scalers/tasks/Chat/hooks/ChatStore.hooks';

export const LinterBackdrop = () => {
  const isValidating = useChatStoreExtract(state => state.isPerStepLinterValidating);
  return (
    <Backdrop open={isValidating} sx={{ zIndex: 100 }}>
      <div className="flex flex-col gap-2 items-center justify-center">
        <span className="text-warning-400 font-semibold">Validating response...</span>
        <Spinner size="md" variant="warning" />
      </div>
    </Backdrop>
  );
};
